/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

// Just some visual indication that page loading is in progress,
App.ready(function() {

  NProgress.configure({ showSpinner: false });

  NProgress.set(0.25);

  $(window).on("beforeunload", function() {
    NProgress.start();
  });

  return $(window).on("load", () => NProgress.done());
});
